// extracted by mini-css-extract-plugin
export default {"bgImage":"royalRegency_bgImage__82And","bgHotelRoom":"royalRegency_bgHotelRoom__qofSY","category":"royalRegency_category__k+HL5","categoryName":"royalRegency_categoryName__FpSuO"};